// extracted by mini-css-extract-plugin
export var questionBox = "_aw-0";